import React from 'react'
import FieldManagementLeftPanel from "./panel/form-left-panel"
import FieldManagementRightPanel from "./panel/form-right-panel"
import ErrorBoundary from "../../../../error-boundary"
import {FieldManagementFormProps} from "../../../render/management-form"
import FormManager from "../../../../gd-form/common/form-manager"

const debug = false
// const debug = "FieldManagementFormProto"

export default class FieldManagementFormProto extends React.Component<FieldManagementFormProps, any> {

    public form?            : FormManager
    public initFormData     : any
    public formStructure    : any

    static defaultProps = {
        isNew: false
    }

    constructor(props:FieldManagementFormProps) {
        super(props)

        this.initFormData = {
            label           : _.get(this.props, 'field.label', ''),
            description     : _.get(this.props, 'field.description', ''),
            fieldAccess     : _.get(this.props, 'field.fieldAccess', gd.const.customFields.access.EVERYONE),
            isRequired      : _.get(this.props, 'field.isRequired', false)
        }

        this.formStructure = {
            fields: {
                label       : {
                    type: 'input',
                    isRequired: true,
                    label: 'Label',
                    validator: (val:any) => {
                        let res:any = true;
                        if (val === null || val === undefined || val.trim() === '') {
                            res = 'Invalid label';
                        }
                        return res;
                    }
                },
                description : { type: 'input',      isRequired: false,  label: 'Description'},
                fieldAccess : { type: 'select',     isRequired: true,   label: 'Access'},
                isRequired  : { type: 'boolean',    isRequired: false,  label: 'Is required'},
            },
            // onSubmit: this.onSubmit
        };

        // this.form = new FormManager(formStructure, initFormData); that should happen in field!
    }

    onSubmit(result:any) {
        debug && console.log(debug, 'onSubmit', result)

        this.props.field.label          = result.label.trim()
        this.props.field.description    = result.description.trim()
        this.props.field.isRequired     = !!result.isRequired
        this.props.field.fieldAccess    = result.fieldAccess

        debug && console.log(debug, 'onSubmit field', this.props.field)
    }

    renderAdditionalControls():any {
        return false
    }

    render() {
        return (
            <React.Fragment>
                <ErrorBoundary>
                    <FieldManagementLeftPanel field={this.props.field} />
                </ErrorBoundary>

                <ErrorBoundary>
                    <FieldManagementRightPanel parent           = {this}
                                               field            = {this.props.field}
                                               isNew            = {this.props.isNewField}
                                               disableRequired  = {this.props.disableRequired}
                                               entity           = {this.props.entity}>
                        {this.renderAdditionalControls()}
                    </FieldManagementRightPanel>
                </ErrorBoundary>
            </React.Fragment>
        )
    }
}